import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=27c4a830&scoped=true&"
import script from "./EventListItem.vue?vue&type=script&lang=ts&"
export * from "./EventListItem.vue?vue&type=script&lang=ts&"
import style0 from "./EventListItem.vue?vue&type=style&index=0&id=27c4a830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4a830",
  null
  
)

export default component.exports